import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { DesktopView } from 'widget/views/desktop';
import LoadingSpinner from '@wix/wix-vod-shared/dist/src/widget/ui-components/loading-spinner/loading-spinner';

import { CHANNEL_LAYOUT_VALUES } from '@wix/wix-vod-constants/dist/app-settings/channel-layout-values';
import { AppSettingsLoader } from 'widget/data-components/app-settings-loader/app-settings-loader';
import { updateCSS } from 'shared/utils/update-css';

const layoutLoaderMap = {
  [CHANNEL_LAYOUT_VALUES.STRIP]: () =>
    import(/* webpackChunkName: "widget/strip" */ 'widget/layouts/strip/strip'),
  [CHANNEL_LAYOUT_VALUES.CLASSIC]: () =>
    import(/* webpackChunkName: "widget/classic" */ 'widget/layouts/classic/classic'),
  [CHANNEL_LAYOUT_VALUES.COMPACT]: () =>
    import(/* webpackChunkName: "widget/compact" */ 'widget/layouts/compact/compact'),
  [CHANNEL_LAYOUT_VALUES.SLIDER_SMALL]: () =>
    import(/* webpackChunkName: "widget/slider" */ 'widget/layouts/slider/slider'),
  [CHANNEL_LAYOUT_VALUES.SLIDER_BIG]: () =>
    import(/* webpackChunkName: "widget/slider" */ 'widget/layouts/slider/slider'),
  [CHANNEL_LAYOUT_VALUES.GRID]: () =>
    import(/* webpackChunkName: "widget/grid" */ 'widget/layouts/grid/grid'),
};

const loadLayoutComponent = id =>
  _.result(layoutLoaderMap, id) || Promise.reject();

@connect(state => ({
  appSettings: state.appSettings,
}))
export default class LayoutSwitcher extends React.Component {
  static propTypes = {
    children: PropTypes.element,
    appSettings: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      LayoutComponent: null,
      layoutId: null,
    };
  }

  componentDidUpdate() {
    const layout = this.getLayoutId();

    if (layout !== this.state.layoutId) {
      this.loadLayout(layout);
    }
  }

  getLayoutId() {
    return _.get(this.props.appSettings, 'numbers.channelLayout');
  }

  loadLayout(layout) {
    loadLayoutComponent(layout)
      .then(component => {
        this.setState({
          LayoutComponent: component.default,
          layoutId: layout,
        });
        // updateCSS here needed for lazy loaded layout chunks
        updateCSS(this.props.appSettings);
      })
      .catch(_.noop);
  }

  render() {
    const Layout = this.state.LayoutComponent;

    return (
      <AppSettingsLoader>
        {appSettings =>
          appSettings ? (
            <DesktopView>
              {Layout ? <Layout /> : <LoadingSpinner />}
            </DesktopView>
          ) : (
            <LoadingSpinner />
          )
        }
      </AppSettingsLoader>
    );
  }
}
